import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSimilarAds = (ads) => {
  return {
    type: actionTypes.SET_SIMILAR_ADS,
    payload: ads
  }
}
